/**
 * pmp-accounting distribution account (Verteilerschlüssel pro Konto).
 * GET returns the editable payload shape; PUT uses POST + x-http-method-override (host parity).
 */
function fetchDistributionAccount({ token, propertyId, year, accountCode }) {
  const params = new URLSearchParams({
    year: String(year),
    propertyId: String(propertyId),
    accountCode: String(accountCode),
  })
  return fetch(`/services/pmp-accounting/api/v1/distribution/account?${params}`, {
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: 'application/json; charset=utf-8',
    },
  }).then((response) => {
    if (!response.ok) {
      return response.text().then((t) => {
        throw new Error(`distribution/account GET ${response.status}: ${t || response.statusText}`)
      })
    }
    return response.json()
  })
}

function putDistributionAccount({ token, body }) {
  return fetch('/services/pmp-accounting/api/v1/distribution/account', {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json',
      'x-http-method-override': 'PUT',
    },
    body: JSON.stringify(body),
  }).then((response) => {
    if (!response.ok) {
      return response.text().then((t) => {
        throw new Error(`distribution/account PUT ${response.status}: ${t || response.statusText}`)
      })
    }
    const ct = response.headers.get('content-type') || ''
    if (ct.includes('application/json')) {
      return response.json()
    }
    return {}
  })
}
